<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<div>URL</div>
			<CombinedInputFieldDataMenu
				class="mb-6"
				:textAreaMode="true"
				:value.sync="imageSource"
				:valuesTypes="dataInputMenuValueTypes"
				:richTextFormat="richTextFormat"
			/>
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
		<ExpansionPanel :title="'Export settings'">
			<template>
				<v-container fluid>
					<v-row align="center">
						<v-col cols="6">
							<v-select
								v-model="fileFormat"
								:items="imageMimeTypes"
								item-text="text"
								item-value="value"
								label="Image format"
								persistent-hint
								return-object
								single-line
							></v-select>
						</v-col>
					</v-row>
				</v-container>
			</template>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import { TEXT_BOX_FORMAT_TYPES } from '@/components/common/RichTextBox/rich-text-box.const';
import SettingSwitch from './WidgetSettings/SettingSwitch.vue';

export default {
	name: 'ImageEditorFieldSettings',
	data: () => ({
		richTextFormat: TEXT_BOX_FORMAT_TYPES.PLAIN_TEXT,
		imageMimeTypes: [
			{ text: 'png', value: 'image/png' },
			{ text: 'jpeg', value: 'image/jpeg' },
			{ text: 'webp', value: 'image/webp' },
		],
	}),
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: { ExpansionPanel, CombinedInputFieldDataMenu, SettingSwitch },
	computed: {
		metadataOptions() {
			return this.localField.metadata.options;
		},
		fileFormat: {
			get() {
				return this.metadataOptions.file_format.value;
			},
			set(newValue) {
				this.setLocalFieldKey('metadata.options.file_format.value', newValue.value);
			},
		},

		imageSource: {
			get() {
				return this.metadataOptions.image_src.value;
			},
			set(newValue) {
				this.setLocalFieldKey('metadata.options.image_src.value', newValue);
			},
		},
	},
};
</script>

<style scoped lang="scss"></style>
